export const settings =  
{
      active: true,
      avatar:'unknown',
      brand:" ",
      closedOn:3, // 1== Monday 
      color:'info',
      conflictAlertTimeframe:20,
      datefrom:new Date().setMonth(new Date().getMonth()-1),
      dateto:new Date(),
      date: new Date(),
      defaultMealDuration:90,
      directBookingLogo:null,
      email: 'scm@jslab.it',
      faqs:null,
      level: 1,
      logo_400_70:'',
      menuURL:'',
      messagesCount:0,
      name: "",
      newBookingsAlert:null,
      requests:null,
      //ownWANumber:'393533300505',
      password:'',
      //phoneBooking:'010990099',
      phoneTechnician:'393203023832',
      tasksCount:0,
      options:{avatar:"male"},
      tempBrand:null,
      tbm:0,
}